import { checkEnvironment } from '@saviynt/common';

/** For use by MFA backend */
export const sessionDetailsApiProtectedUrl =
  '/ECMv6/api/pam/privilegedinstance/sessions/*';

const getSessionDetailsApiUrl = (requestAccessKey, userKey) => {
  const { GATEWAY_API_URL } = checkEnvironment();

  return `${GATEWAY_API_URL}/api/pam/privilegedinstance/sessions/${requestAccessKey}?userkey=${userKey}`;
};

export default getSessionDetailsApiUrl;
